import { ButtonSize, ButtonVariants } from '@anm/components/buttons/Button';
import Dialog from '@anm/components/modals/Dialog';
import Confirm from '@anm/components/notification/Confirm';
import { FC } from 'react';

type DiscardChangesModalProps = {
  onCancel(): void;
  onDiscard(): void;
};

const DiscardChangesModal: FC<DiscardChangesModalProps> = ({ onCancel, onDiscard }) => {
  const handelRightButtonClick = () => {
    onDiscard();
    onCancel();
  };

  return (
    <Dialog onModalClose={onCancel} onSubmit={handelRightButtonClick}>
      <Confirm
        title="Discard changes"
        buttonLeft={{
          text: 'Cancel',
          size: 'upper-medium' as ButtonSize,
          variant: 'silver-border' as ButtonVariants
        }}
        buttonRight={{
          text: 'Yes, discard',
          size: 'upper-medium' as ButtonSize,
          variant: 'red' as ButtonVariants
        }}
        onLeftButtonClick={onCancel}
        onRightButtonClick={handelRightButtonClick}
      >
        You’ve edited some live stream settings, would you like to discard these changes?
      </Confirm>
    </Dialog>
  );
};

export default DiscardChangesModal;
